import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import isAccessTokenValid from '@app/helpers/isAccessTokenValid'
import isUserLoggedIn from '@app/helpers/isUserLoggedIn'
// @ts-ignore
import * as syncNotifications from '@app/actions/notifications/notificationsChannel'
import { withAccessDenied, withNotifications, withProgressAndErrorMessage } from '@app/hocs'
import { isIOS } from 'react-device-detect'
import EditCondition from '@app/components/MyAutomation/Tabs/ScenesScreens/EditCondition/EditCondition'
import EditConditionIOS from '@app/components/MyAutomation/Tabs/iOS/EditCondition/EditCondition'
import { AppState } from '@app/@types/store'
import { AppDispatch } from '@app/store'

const isWebView = navigator.userAgent.includes('WebView') || navigator.userAgent.includes('wv')
let enhance = isIOS && isWebView ? EditConditionIOS : EditCondition

const mapStateToProps = (state: AppState) => {
  const { isMobile } = state.mobileDetector
  const { path } = state.shadowIn
  const { currentCondition } = state.scenes.currentSceneCreating
  const { sceneMode } = state.scenes.currentSceneCreating
  return {
    isMobile,
    path,
    sceneMode,
    currentCondition,
    editedConditions: state.scenes.currentSceneConditionsActions.conditions,
    accessDenied: !isAccessTokenValid(state.secrets.accessToken),
    userLoggedIn: (isUserLoggedIn(state.users.currentUser.user.preferredName)),
    inProgress: state.apiRequest.inProgress,
    errorMessage: state.apiRequest.errorMessage,
  }
}

const mapDispatchToProps = (dispatch: AppDispatch) => bindActionCreators({
  notifications: syncNotifications.sync,
}, dispatch)

enhance = withNotifications(enhance)
enhance = withAccessDenied(enhance)
enhance = withProgressAndErrorMessage(enhance)
// @ts-ignore
enhance = connect(mapStateToProps, mapDispatchToProps)(enhance)

const EditConditionEnhanced = enhance

export default EditConditionEnhanced
